import { render, staticRenderFns } from "./BpmnSubController.vue?vue&type=template&id=b50d446e&scoped=true&"
import script from "./BpmnSubController.vue?vue&type=script&lang=js&"
export * from "./BpmnSubController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50d446e",
  null
  
)

export default component.exports